import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "main-table",
  id: "content"
}
const _hoisted_2 = { class: "main-top-box" }
const _hoisted_3 = { class: "main-top" }
const _hoisted_4 = { class: "main-top-num" }

import { ref, reactive, onMounted } from "vue";
import { getListExamUsers, getExamInfo, getStatistics } from "@/api/backstage";
import { useRoute } from "vue-router";
import * as echarts from "echarts";
import html2canvas from "html2canvas"; // 引入插件


export default /*@__PURE__*/_defineComponent({
  __name: 'questionnaireStatistics',
  setup(__props) {

const route = useRoute();

const datas: any = reactive({
  form: {
    id: route.query.id,
  }, //接口入参
  echarts1Tit: "", //图表1标题
  echarts2Tit: "", //图表2标题
  echarts3Tit: "", //图表3标题
  echarts4Tit: "", //图表4标题
  echarts5Tit: "", //图表5标题
  echarts6Tit: "", //图表6标题
  echarts1X: [], //图表1
  echarts1Data: [], //图表1数据
  echarts2Data: [], //图表2数据
  echarts3Data: [], //图表3数据
  echarts4DataX: [], //图表4X轴数据
  echarts4DataY: [], //图表4Y轴数据
  echarts5DataX: [], //图表5X轴数据
  echarts5DataY: [], //图表5Y轴数据
  echarts6DataX: [], //图表6X轴数据
  echarts6DataY: [], //图表6Y轴数据
  total: 0,
  datasList: [],
});

async function downLoad() {
  const content: any = document.getElementById("content");
  html2canvas(content).then((canvas) => {
    const link = document.createElement("a");
    // console.log(canvas, "canvas");

    const event = new MouseEvent("click");
    link.download = "下载.png";
    link.href = canvas.toDataURL();
    link.dispatchEvent(event);
  });
}

/*
 * @FunctionName: initEcharts
 * @Description: 图表1
 * @Author: csx
 * @Date: 2024-05-28 09:14:51
 * @Version: V1.0.0
 */
const initEcharts = () => {
  let chartDom = document.getElementById("mainCenterleft");
  chartDom!.removeAttribute("_echarts_instance_");
  // 将创建的echarts示例放到vue的data中，这样在这个界面就想到于全局配置了
  const myChart = echarts.init(chartDom);
  // let giftImageUrl =
  //   "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAANgAAADICAYAAACK9i92AAAU50lEQVR4nO2d7XXbuBKGXUJKUAnuIOwg7sDowOnA6iDpgOzA7sDqIO5A6kDq4NkfINeMog9iZvBBEs85Pufu3RUxAPESwGAweHioVAwAvgHf+7/X/u8N+Ljz1/b/7XP/203uulQqWQE2vSBee5EcsecP8KsvZ5O7zpVKNPrR6bkfbfYRxDSFY1/+j9ztUamoAR6BF/xIUhqD2J5zt1OlMhn81K9UUV3jiJ+qbnK332rAd5Tv+M7yyuXF9Zjzf/er/92P/jnfctcpJn093+z7fnJaoMndnosCP5V57hs35pf3iO+EryxAdPh11Qv51lQx+aAKTQZf05g34nivQhg8XY+522Uq+PZ7JX/bpaClTh3vwzzWBkV7ufBt2OZsoIy0zHzGYQ5fruE5rg2O+JFtU0g7vrKOEesWR+Ap9/vIDsvrEB9kciezrHa04o01jmYsfwqzJ5HQgCfSOy8OwDuwBX4CDXccDfh33gCu/10HfCawdT2jGcsX1jl7IgkN35apptQ7vCgajEcE/Cym6Z8fU3Ctpd1FwddUcK3sMXQl451AMaeDJ/wI80TiKRb+w/GTOGL7k7o+0SHPFKZUPlA4Q/Cd7yOife8UNJ3q69sZ1/HIjLZarkL8zjBnXgXtGWvUOuBHjGK/7PgZ0BY/slrhctdLDH4hWz1at/nDhC8pvnPFWGvtmFkn40toVsxrXUa8zmDBCd+pxn+HrBZ5Xm605yP2H6odMw8tws+O3o3aYx4iw3eGvVGlJYxdx47ATsSXG/mpf8YO2ynJLT44m6L1dbBk9sI6B/++LD6SZe+XYd8ZpnDAL4AdEaMo8MJ76suKKbj/PVzYbmUcmNlUMAT8rMnCEVKmhxEfJpSKA/CbjF4g/Ej9mzjTyz12jqETsM3VTqnBfwS1H8CyREa6TeOOgtzHA/iXarUWsGRHAbGRqcHPNrT7Z2+56zEMyx/KikyhYwYdBf9if5NuzXaNE/Azd3vkBN83tR+9fI6PvgKxj5JsmYGwziHOfs1UVjlqXQP/wdOwzWF0bHEtopMQJwLhFqseta6B3vmWdllCvDXXIXllEoB3I8cMYD2xhLCfiKAT2ZFUH3ziies3JXluIoBt9MHA59LbzQp0IvtIYWBr0iX+5sQCR61r4N37Vq79Lnd95gY6N/42pmExNpE/WcBaKxT8Gla7+O5y12Ou4KfsUuyn4sSJhevMDZ0R6GYDLrf9cwf5gPHH2pAYHsPfpkbODOTiOlHFZQbyWYSzNMI6Kt7OuBmCTlzVU2gMsm2UIxaOJfwBPEucvknmC3JxfVLFFQ1kWyhbbaHfsF13OZPWmCnoxFXd8BHB+xgkbDSFWk4Nt2atMUOQi6ujiisJyGZrMl8COjfmP53EtinmBQpx5bZ9beBD9EIIX4vhp4Z7Yac45zNSW8wCqrhmBT52NJRtaCFW4TwnVriJPEAV1ywR9P99yMMtHRtNvGYoF3Rn5Lrc9q+d/v2FhlK5qQ+3Gr22UVuhUNBtyne57a94CHd4vE95qNXodWCFni+quBYF4QHZt/s8dqNXk6YJyoEqrsUh0IO79TCr0ev+ULkwqOJaJIR7FK/3fWyOopxY2dSQKq5FQ3ic4uX+j01mqFVFyFPFtXgID7hoLj1Esrl2iU3yFsgEVVyrgTCX/fbSAyycG13ymmeCKq5VQdg0cXfpAXthZxmzSV7zDFDFtToI9E+c/9giqHcVnkOquFZJ/95DeBz/2GJ6uPiMUFRxrRrCDmS68Q9Dw/PPOeWrdhrQ3XfW5ba/ooewddh2+FHo0HeJRbvm0WXT6nLbL4GvYOWaoqCHsJleN/zoSdhxxjRZax4RViiuh4e/TrIfqSJ7eHgI9lXshh9pE18udnrIesV1/qWuInsI3iveDz/Srr8W6T1kveK69pVOd/FBwYR0guAfXGFxV+WwXnFt7tS7rCtVMxDSEawcHIuaOrBecU3dgli1yEI6g8kGc+4KW8JKxfXwEJw7ZLUiI+AApkXG3sVki2Ld4pL0g1WKjACfhYUHcREODtYtLs0sZnUiI1BgWg/iNneFtbBucVlcR7UqkZFYYC53hTWwbnFZJpZdjchILLAmd4WloEuP0OW2XwNx7nqzvZCuUKgCuw9VXNbiGmhz1y82IY1hscnc5K5wKFRxxRLXwKJFFtAOn6sTGFVcHwbvfAqLFBlhgRk7C4HNZmFLFVfskeucxYmM0Gh6g0Zscld6CujEtcttvwbyiGtgUSIjrB9tVyGwwEY5Z9bXtpJXXAOLERlhBy5/huZ6u0STu9K3oIrLQlzv6PvJIkRGmNe9sXDTF5vohnWLS5M/ZEw3ep5WZNu8raInsL6bxYZKoctSPHdxNdhc4NGdPddCZC5Pq+jp6z+Z4Ufvygbb5q32dZClojswb3G9KN/nQHfl+asVGWEnDnbDjySd8N8HFQrht2LADDsAfr3VKt/lQHenrFWKjLDB6PfwI63AjpnrfRfCkkUOvOS2eyr4Dm/lKewCylyVyAibdrvhR+oTzRQ+pcJ/3SefQh1RvOcLuykhBOa2ZEUiIzy14Wb4ocYZMNBkrf0EkHeGPxSYSal/bx8G727ACe1YhcgIO5h8OP+xtoFmkdUX+Wh9BJ5z2z8AvCrf15gTyg7OCkRG2JZHd/5jrat+NueA0O2NfZBxNAOesTsgCV4UJhnBsBFZY2GLNYR/mN35A7R5OaDwddgYZJ7FgSN+BElWX7ywrMOdPjH+WKAXWZHZg9Hez4xNbnqXp/oy0F/2HlVoeMfMM7Yj1kAX0e5FiQz/HkK8h/8mgcIm+ejsskuhF9nAG/DDyKYf+P0si0iMS0TPwsyCREZ4H7ncvsj2is6ZzTRxQNCAtzjixfYCfJ9Y/vf+v3+78VwLDiTstCxEZIRPzTfXHmSxDptljnr8FFm7QL/GHu8cOf+LNUJdItqU8E67zlpkhDs3rs/iCAxkvMI+Yf1N6etvMYqXxInMpx2YscgId264ew+URDucU+zxlXvg16LaLYtSyDJqXYIZiozwAIzT3fbGZpr4kagNooGPmo41ZYzNgQL3k9CLbE/arZHQ0aub8lCLaSIU+IJDwX/B5jSaqSMyYoNeZEmyB3P/jrRLTBthsZkmzn4UG8B7GUsezU74ExFFTAfvwQxERvjoNf2GIezc1tnWYvi11PezP/Ecvn/elrKENithjaFgkSELfnchBXxTVn5gH6sRLtj8iI+qmHo7Y4tgY5gvoVmM8lI+KXwqOAUKFRnho9dBUoiFswMiphPAd/ZXdKFE4nAn/Eifao12wL+T7BuvllCYyIg9eikLuoZ5p8CLwnKj9oj8PNQ3vNg6bKeQO/xouShRnUNBIiP8fN191/yNwjQR52PM9jCwPRp/CfUJ5t7GJ7w43vFCubaBfer//SAmxwI8sKFQgMiQBbzLI5ewHcXUIsN3vhThRcWnCVgi6EX2pix/H1jewaLSVqMYeHGIPIvYnuCdglM3XiUY9CITfRyRJX5yFhXeKCusNgy7VGQhFBHJvUZILDJkM7WDZYUl6r6Hm1h2G6HsqcwmDcLSIKHIkCUOaqwrHCPK3N0ps41QZig3bazEgwQiIyxT78AuRmVDz8VMxV0pr41UXiizPX6zBIgosv7ZEqfZJlZltTnsr+HOymkFzzjhN2Kf8B+DBru9KXe5RSopIJLIkG33bGNX1irC4xzXP78V/PZmPB5+I1hj9+xyjSwNjEUm7A/TA3qVlbUKBj7nQ/Abl8LuiM1ZmQh6kf3snyNd7qTzKhNPZCE4gd1Sj+hsT2kvCfTpBV+Rrbu2OSqbU2ROaLP0EoitbetVpJC+36WZGhZSWdDnUZdEp8wi934p8JU0teXvTFpv/f+vjRtM1e9O5L74I2FlwcCjJ7R3p2+pdcC062v3KKfdwvcYShlLg0SVdUa2Sha5O4uylw7he0tOWV7MflfWrCVyZZ2hnRahX3v8lOcXEzP4Lh38tHCf+t0Sp9/tbFrFGGyusDnHGdsYY8M8+Y0rpYHuw+WUZVuK7JOS3yO2InPGtlmecbvEEXi1tHkuoD+r55TlW4hMfkI5JUaVdcY2fSPuaegxSfL3lQJ2+TSd0g5tvyv/mBLyIEqzhr5iV6u0KZQ9pb8sI7ANBndKW5YrMqq4zjmSex8lAdiftnBKe7QiK28GQhXXNVZxcDNCuzmlPVqRleOmp4rrHotPpINt/pYBp7RJK7LGpnV0lQi9w9a8Ia/YlMqhMZXGso6lQZz8LZBXZHnvWMCmI7sCbYrBYi7EuAbxgg1cRrsam9aRGa6NinDG9liIazgd/Th67iM+f4MkEn9MY1nfEmF5Istz4Bb9pq0ztsdCXHd38ZElShnoLOtcKpQrMmkQRHqPIrpFrTO2xUJcXUB50he1miQ6lCsyyZZC2qh6fIfO0kBXbEkmrlG50g5U5iZmBBRtdA+ntCt0cEjrskfecM7YjiziGpVfT0ffgQJFRnjqgZ1di0wzUBKRLr+J4rINWcXV2yDJTrS1aYF44KfAz8ALBsdxKExkhE8Tj9o2CDUwlINx+dnF1dsh8aKqy40Ft6+HekWx2KcgkSFIniOttwhBI2wNyy5CXL0tEoHtLMq2hmnROKoYPQoRGYL3Jq1zMMjc841R2cWIq7dHMlXe85UE5hd+ZHgho/MD/06nRuPMXmQI3pu0vsEgc3M2BuWWJi6rM1Bj9njRbazsnFiX0A43W5EhGyBO0roGg8xF3xiUWZK4UoRjtSTY4ES+5TJLkeFTx4Wyk9ZThMDAraKsNYprQHw5e0B9NGe5ShVZy9ksAPiB/L112nYObZjQKIadsJw1i2tMtDwf6A9LliqyAYt7vZ1hk09qFMnifhNYRhXX30Q7U4b+mEnpItOSNhYRWYNsA55fxXUZ0836Uf12BrYtVWTpo+mRLYwnJROhiusejVXdRnXUHjsaWKLIGsOmDmoMSTT9EXi+8cyGKq57mEfk4+tpdQ/3kkS2M2zm4Ib4hnzuvudrk3X4s+jInXH9ShPXwNaqnmf11RxBGrMEkRVxs4rV1MKCzrBeluI64DvudvSnHS2ORFp4U0U2UMzNKlZTCw2dYX2sxHXihlMCHwmiabsoDo/etrWvyZxhc+rAdv4uoTOui5W4JsUWIh8xonq3sOvccxLZiRLzppBPZJ1xHZKKa1S26MYXq7rfsGtNIttR8mlzfAe12E+ZSmdsexZxjcqX0Fi1wQ3bShFZrL51oJT11hSQnfINpTO0N6u4RnZIRrGtVTvcsS27yAxtAP+uOuYkrDH4IwExLroDw1vfKURcvS0Sx8LWqCmm2JdVZOhiJj/x7esocY0lpW+UDn3CzjGNkW3FiKu3RyKwpNmOyCgyZdnzHKlCwLulh32gDj+n3hG2WW1y8I3CxNXbJPEm/gG+kzAYFZ/PwiIHfZDI0C09ynVexIawxevOoLwSxWVxgQb4CJkWnxEqmuiwuyZ4kshQtk+sdpgFJBQYBYqrtyuWY6glUrgPCUWGbuM7T275UiDcGSL1QpUqrhR7PG9EGNGwE9meK2trfEIgDctff92C8K9TcIgQ6xbXwBF4sbJ9VAcrkYF/R0MQeIt+2pwuWU2pEJ4EMuiSaqq4zmkxnjZiKzJLtpb1nCWUf3gTliOuMXsMRzTKE9mB0i4yzwWyTembUx68J83CM7dEcY35wKgj4kVmueepYd1rrzHoOt0RP+155Wvuvte9m/9ZurgGVHGCZ3XMfboCCs7/nw3K+fINrEVcA0sR2c6iDouDsjpgyeL6xE+pO+w78dxF9mll/yLJ8EIuUaq4Oi54//AdeYvdDOAPthEqqd7pO1Vct0GXSMeCUsXlJradVWcO2gq5Y9fGyKZbdBa2rgLi3FoyhdmKa1SmZWe2FFmso0vzOixZCthFbE9l9uIala2J2zvHRGTGNsGdhEKVCZBuT2Ux4urLl6YfuIZaZAiubL3AAR8UXUcsK7BNhnkJa3H9MrLLKe2wnpIdUXRsZAJ7xx/YbTRtUZkAfm0RcqxlKmbTDPwGtwXOwBbrKZnKNmTHcdTtUAkEP6I5/NfNYo1mtefTGtgCRp2KuImHgm1EFlnTWLRFRQledA3hHrSdUfmtoPNcwlnY09tkEYNpYivyNenGqj0qRhC2D7QzKK8Vdp5znL72/9sUa3oYbDPeUSUR+8GqPSqGELZOU10DRJniSh1u9uuGLc/IR9Kk2bIqEyHcESLyIFLFNabFZ7Ya/l7Qn8FbbxaokiF8evQhKKNVdp4BZ1jvkgKltZgllq0YgyzMavLl4ixLXDvFb2PSWLVNJQLI3Pc3sy7hPZWtUQdyhnXVCMQZPMOazqptKpFAHvlxxEdifMe7/Df9//6FndvbGdZTI4xPw2dZkf/K1sp9SHM8QoIzrKM2V+A/TgTyisw0ZK0SGeLGL0pwhnVrY9lCvju3q7jmBH4UKyWFmDOsV6u0pZtQRsrcKGVe2Vq5D2WsK5xhfVqlLd3EclKNYp/UkWvekHeq6Azr0SptmXxqAPvzZJfoqPkzlgHxjqvfwhna36a2xaD+1/ikTgmXB2kX787Q7jaHLdglbh3YSW2pzAT8qdrYC3hnZKvVxvbkKJWz8i34xJ9L21i0SWUm4EezGB5Gkwhw7C6sGHCB5Wuyer1Tp4AVvk5Gd9iJbWNkl6W4Bibn00DnGGq0bVBZIPivdoOfRm4JX7MdDGyIJS6Yft2TNidl9QxWphHYsXbKsmKKa+CIv31mc8WGR3TOjXrMpDIdwg5vHhXlpBDXOX/4+8qnN4Nnbg2bv7J0SHA6mjziisUmwmuoLBXCF/tvgc9/ZDnieo/1HioLBVkso5v4bGm2pVKpMYWVMJDH5N3c3EUvrhNe/KWcFqgZoCoykKfr/gP8OHvWI/rc9f8fTOyfl1tkJ6prviKFMo68DPxz6pe8dyHXU8gVPZRxOfvVu4fJJzKX+FVUlgg2d1tpuHuxN+lF5hI1f2UNkOdMGUwQ15mdsQ+Y1iP+FXvIMw0LEtfI1lgexk/qZnIlFqT12onENbLV8mbQA3VKWEkBXmSxR7Ktob0b/KFHiaOmnkKupAc/OsRYkx2IuL7Bfxx+9rbv+PpQnPp/3uFHvSfq3lYlN/jzYxajWZ2CVSrX4OvO6BBO/W9cbvsrldnA14nobjTt2vViGk5K1+iHFfEfr+O3U1DnXBYAAAAASUVORK5CYII=";
  let option = {
    title: {
      text: datas.echarts1Tit,
      left: "center",
      top: 10,
      textStyle: {
        color: "#666666",
        fontSize: 12,
      },
    },
    // backgroundColor: '#f7f7f7',
    // tooltip: {
    //   trigger: "item",
    //   formatter: "{b} : {d}% <br/> {c}",
    // },
    tooltip: {
      axisPointer: {
        type: "shadow",
      },
      trigger: "item",
      formatter: "{b} : {d}% <br/> {c}",
      confine: true, // 是否将 tooltip 框限制在图表的区域内
      position: function (pos, params, dom, rect, size) {
        // 自定义提示框位置，可根据需要调整
        return [pos[0] + 10, pos[1] + 10];
      },
    },
    // graphic: {
    //   elements: [
    //     {
    //       type: "image",
    //       style: {
    //         image: giftImageUrl,
    //         width: 50,
    //         height: 50,
    //       },
    //       left: "center",
    //       top: "center",
    //     },
    //   ],
    // },
    legend: {
      orient: "horizontal",
      icon: "circle",
      bottom: 2,

      x: "center",
      textStyle: {
        color: "#000",
      },
      data: datas.echarts1X,
    },
    series: [
      {
        type: "pie",
        radius: ["40%", "50%"],
        center: ["50%", "44%"],
        color: [
          "#0E7CE2",
          "#FF8352",
          "#E271DE",
          "#F8456B",
          "#00000F",
          "#4AEAB0",
        ],
        data: datas.echarts1Data,
        labelLine: {
          normal: {
            show: true,
            length: 20,
            length2: 20,
            lineStyle: {
              color: "#12EABE",
              width: 2,
            },
          },
        },
        label: {
          normal: {
            formatter: "{c|{c}}\n{hr|}\n{d|{d}%}",
            rich: {
              b: {
                fontSize: 12,
                color: "#12EABE",
                align: "left",
                padding: 4,
              },
              hr: {
                borderColor: "#12EABE",
                width: "100%",
                borderWidth: 2,
                height: 0,
              },
              d: {
                fontSize: 12,
                color: "#000",
                align: "left",
                padding: 4,
              },
              c: {
                fontSize: 12,
                color: "#000",
                align: "left",
                padding: 4,
              },
            },
          },
        },
      },
    ],
  };
  option && myChart.setOption(option);
};

/*
 * @FunctionName: initEcharts2
 * @Description: 图表2
 * @Author: csx
 * @Date: 2024-05-28 09:14:51
 * @Version: V1.0.0
 */
const initEcharts2 = () => {
  let chartDom = document.getElementById("mainCenterCenter");
  chartDom!.removeAttribute("_echarts_instance_");
  // 将创建的echarts示例放到vue的data中，这样在这个界面就想到于全局配置了
  const myChart = echarts.init(chartDom);
  let color = [
    "#6597FB",
    "#5FF5E8",
    "#18BEF7",
    "#F67C2D",
    "#ffdb5c",
    "#aa6eff",
  ];
  let echartData = datas.echarts2Data;

  let total = echartData.reduce((a, b) => {
    return a + b.value * 1;
  }, 0);

  let option = {
    title: {
      text: datas.echarts2Tit,
      left: "center",
      top: 10,
      bottom: 50,

      textStyle: {
        color: "#666666",
        fontSize: 12,
      },
    },
    grid: {
      bottom: 10,
      top: 150,

      left: 0,
      right: "10%",
    },
    tooltip: {
      trigger: "item",
      formatter: "{b} : {d}% <br/> {c}",
    },
    // backgroundColor: '#000',
    color: color,
    // title: [
    //   {
    //     text: "{val|" + total + "}",
    //     top: "center",
    //     left: "center",
    //     textStyle: {
    //       rich: {
    //         val: {
    //           fontSize: 32,
    //           fontWeight: "bold",
    //           color: "#000",
    //         },
    //       },
    //     },
    //   },
    // ],
    series: [
      {
        type: "pie",
        radius: ["40%", "60%"],
        center: ["50%", "55%"],
        data: echartData,
        hoverAnimation: false,
        labelLine: {
          normal: {
            length: 10,
            length2: 20,
            lineStyle: {
              color: "rgba(75, 219, 198, 1)",
            },
          },
        },
        label: {
          normal: {
            formatter: (params) => {
              return (
                "{name|" +
                params.name +
                "}" +
                "\n" +
                " {value|" +
                params.value +
                "次" +
                "}"
              );
            },
            rich: {
              name: {
                fontSize: 10,
                fontFamily: "PingFang SC",
                fontWeight: 400,
                color: "auto",
                lineHeight: 20,
                align: "center",
              },
              value: {
                fontSize: 13,
                fontFamily: "Source Han Sans CN",
                color: "#000",
                fontWeight: 400,
                lineHeight: 16,
                align: "center",
              },
            },
          },
        },
      },
    ],
  };

  option && myChart.setOption(option);
};

/*
 * @FunctionName: initEcharts3
 * @Description: 图表3
 * @Author: csx
 * @Date: 2024-05-28 09:20:51
 * @Version: V1.0.0
 */
const initEcharts3 = () => {
  let chartDom = document.getElementById("mainCenterRight");
  chartDom!.removeAttribute("_echarts_instance_");

  // 将创建的echarts示例放到vue的data中，这样在这个界面就想到于全局配置了
  const myChart = echarts.init(chartDom);
  let color = [
    "#6597FB",
    "#5FF5E8",
    "#18BEF7",
    "#F67C2D",
    "#ffdb5c",
    "#aa6eff",
  ];
  let echartData = datas.echarts3Data;

  let total = echartData.reduce((a, b) => {
    return a + b.value * 1;
  }, 0);

  let option = {
    title: {
      text: datas.echarts3Tit,
      left: "center",
      top: 10,
      bottom: 50,

      textStyle: {
        color: "#666666",
        fontSize: 12,
      },
    },
    grid: {
      bottom: 10,
      top: 150,

      left: 0,
      right: "10%",
    },
    tooltip: {
      trigger: "item",
      formatter: "{b} : {d}% <br/> {c}",
    },
    // backgroundColor: '#000',
    color: color,
    // title: [
    //   {
    //     text: "{val|" + total + "}",
    //     top: "center",
    //     left: "center",
    //     textStyle: {
    //       rich: {
    //         val: {
    //           fontSize: 32,
    //           fontWeight: "bold",
    //           color: "#000",
    //         },
    //       },
    //     },
    //   },
    // ],
    series: [
      {
        type: "pie",
        radius: ["0%", "60%"],
        center: ["50%", "55%"],
        data: echartData,
        hoverAnimation: false,
        labelLine: {
          normal: {
            length: 10,
            length2: 20,
            lineStyle: {
              color: "rgba(75, 219, 198, 1)",
            },
          },
        },
        label: {
          normal: {
            formatter: (params) => {
              return (
                "{name|" +
                params.name +
                "}" +
                "\n" +
                " {value|" +
                params.value +
                "次" +
                "}"
              );
            },
            rich: {
              name: {
                fontSize: 10,
                fontFamily: "PingFang SC",
                fontWeight: 400,
                color: "auto",
                lineHeight: 20,
                align: "center",
              },
              value: {
                fontSize: 13,
                fontFamily: "Source Han Sans CN",
                color: "#000",
                fontWeight: 400,
                lineHeight: 16,
                align: "center",
              },
            },
          },
        },
      },
    ],
  };
  option && myChart.setOption(option);
};

/*
 * @FunctionName: initEcharts4
 * @Description: 图表4
 * @Author: csx
 * @Date: 2024-05-28 09:36:51
 * @Version: V1.0.0
 */
const initEcharts4 = () => {
  let chartDom = document.getElementById("mainBottomLeft");
  chartDom!.removeAttribute("_echarts_instance_");

  // 将创建的echarts示例放到vue的data中，这样在这个界面就想到于全局配置了
  const myChart = echarts.init(chartDom);
  let option = {
    // tooltip: {
    //     trigger: 'axis',

    // },
    tooltip: {
      axisPointer: {
        type: "shadow",
      },
      trigger: "item",
      formatter: "{b} :  {c}",
      confine: true, // 是否将 tooltip 框限制在图表的区域内
      position: function (pos, params, dom, rect, size) {
        // 自定义提示框位置，可根据需要调整
        return [pos[0] + 10, pos[1] + 10];
      },
    },
    title: {
      text: datas.echarts4Tit,
      left: "center",
      top: 20,
      bottom: 30,

      textStyle: {
        fontSize: 12,
        color: "#666666",
      },
    },
    grid: {
      top: "25%",
      right: "3%",
      left: "10%",
      bottom: "12%",
    },
    xAxis: [
      {
        type: "category",
        data: datas.echarts4DataX,
        axisLine: {
          lineStyle: {
            color: "#000",
          },
        },
        axisLabel: {
          margin: 10,
          color: "#000",
          textStyle: {
            fontSize: 12,
          },
          formatter: function (value, index) {
            return value.length > 2 ? value.substr(0, 2) + "..." : value;
          },
        },
        axisTick: {
          show: false,
        },
      },
    ],
    yAxis: {
      interval: 1, //相差
      type: "value",
      axisLine: {
        //坐标轴样式
        show: false, //不显示
      },
      axisLabel: {
        color: "#000",
      },
      splitLine: {
        //分隔辅助线
        lineStyle: {
          type: "dashed", //线的类型 虚线0
          opacity: 1, //透明度
          color: "#e2e8f2",
        },
      },
    },

    series: [
      {
        type: "bar",
        data: datas.echarts4DataY,
        barWidth: "28px",
        itemStyle: {
          normal: {
            color: new echarts.graphic.LinearGradient(
              0,
              0,
              0,
              1,
              [
                {
                  offset: 0,
                  color: "rgba(0,244,255,1)", // 0% 处的颜色
                },
                {
                  offset: 1,
                  color: "rgba(0,77,167,1)", // 100% 处的颜色
                },
              ],
              false
            ),
            shadowColor: "rgba(0,160,221,1)",
            shadowBlur: 4,
          },
        },
        label: {
          normal: {
            show: true,
            lineHeight: 30,
            formatter: "{c}",
            position: "top",
            textStyle: {
              color: "#00D6F9",
              fontSize: 20,
            },
          },
        },
      },
    ],
  };
  option && myChart.setOption(option);
};

/*
 * @FunctionName: initEcharts5
 * @Description: 图表5
 * @Author: csx
 * @Date: 2024-05-28 09:55:51
 * @Version: V1.0.0
 */
const initEcharts5 = () => {
  let chartDom = document.getElementById("mainBottomCenter");
  chartDom!.removeAttribute("_echarts_instance_");

  // 将创建的echarts示例放到vue的data中，这样在这个界面就想到于全局配置了
  const myChart = echarts.init(chartDom);
  let option = {
    title: {
      text: datas.echarts5Tit,
      left: "center",
      top: 20,
      textStyle: {
        color: "#666666",
        fontSize: 12,
      },
    },
    // tooltip: {
    //     trigger: 'axis',
    //     axisPointer: {
    //         type: 'shadow'
    //     }
    // },
    tooltip: {
      axisPointer: {
        type: "shadow",
      },
      trigger: "item",
      formatter: "{b} : {c}",
      confine: true, // 是否将 tooltip 框限制在图表的区域内
      position: function (pos, params, dom, rect, size) {
        // 自定义提示框位置，可根据需要调整
        return [pos[0] + 10, pos[1] + 10];
      },
    },
    color: ["#3398DB"],
    // tooltip: {
    //   trigger: "axis",
    //   axisPointer: {
    //     // 坐标轴指示器，坐标轴触发有效
    //     type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
    //   },
    // },
    grid: {
      left: "3%",
      right: "4%",
      bottom: "3%",
      containLabel: true,
    },
    xAxis: [
      {
        type: "category",
        data: datas.echarts5DataX,
        axisTick: {
          alignWithLabel: true,
        },
        axisLabel: {
          margin: 10,
          color: "#000",
          textStyle: {
            fontSize: 12,
          },
          formatter: function (value, index) {
            return value.length > 2 ? value.substr(0, 2) + "..." : value;
          },
        },
      },
    ],
    yAxis: {
      interval: 1, //相差
      type: "value",
      axisLine: {
        //坐标轴样式
        show: false, //不显示
      },
      axisLabel: {
        color: "#000",
      },
      splitLine: {
        //分隔辅助线
        lineStyle: {
          type: "dashed", //线的类型 虚线0
          opacity: 1, //透明度
          color: "#e2e8f2",
        },
      },
    },
    series: [
      {
        name: "直接访问",
        type: "bar",
        barWidth: "40%",
        data: datas.echarts5DataY,
      },
    ],
    label: {
      normal: {
        show: true,
        position: "top",
        formatter: "{c}",
      },
    },
    itemStyle: {
      normal: {
        color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
          {
            offset: 0,
            color: "rgba(17, 168,171, 1)",
          },
          {
            offset: 1,
            color: "rgba(17, 168,171, 0.1)",
          },
        ]),
        shadowColor: "rgba(0, 0, 0, 0.1)",
        shadowBlur: 10,
      },
    },
  };
  option && myChart.setOption(option);
};

/*
 * @FunctionName: initEcharts6
 * @Description: 图表6
 * @Author: csx
 * @Date: 2024-05-28 10:13:51
 * @Version: V1.0.0
 */
const initEcharts6 = () => {
  let chartDom = document.getElementById("mainBottomRight");
  chartDom!.removeAttribute("_echarts_instance_");

  // 将创建的echarts示例放到vue的data中，这样在这个界面就想到于全局配置了
  const myChart = echarts.init(chartDom);
  let option = {
    title: {
      text: datas.echarts6Tit,
      left: "center",
      top: 20,
      textStyle: {
        color: "#666666",
        fontSize: 12,
      },
    },
    tooltip: {
      axisPointer: {
        type: "shadow",
      },
      trigger: "item",
      formatter: "{b} : {c}",
      confine: true, // 是否将 tooltip 框限制在图表的区域内
      position: function (pos, params, dom, rect, size) {
        // 自定义提示框位置，可根据需要调整
        return [pos[0] + 10, pos[1] + 10];
      },
    },
    // tooltip: {
    //     trigger: 'axis',
    //     axisPointer: {
    //         type: 'shadow'
    //     }
    // },
    grid: {
      top: "15%",
      right: "3%",
      left: "10%",
      bottom: "12%",
    },
    xAxis: [
      {
        type: "category",
        data: datas.echarts6DataX,
        axisLine: {
          lineStyle: {
            color: "rgba(255,255,255,0.12)",
          },
        },
        axisLabel: {
          margin: 10,
          color: "#000",
          textStyle: {
            fontSize: 12,
          },
          formatter: function (value, index) {
            return value.length > 2 ? value.substr(0, 2) + "..." : value;
          },
        },
      },
    ],
    yAxis: {
      interval: 1, //相差
      type: "value",
      axisLine: {
        //坐标轴样式
        show: false, //不显示
      },
      axisLabel: {
        color: "#000",
      },
      splitLine: {
        //分隔辅助线
        lineStyle: {
          type: "dashed", //线的类型 虚线0
          opacity: 1, //透明度
          color: "#e2e8f2",
        },
      },
    },
    series: [
      {
        type: "bar",
        data: datas.echarts6DataY,
        barWidth: "20px",
        itemStyle: {
          normal: {
            color: new echarts.graphic.LinearGradient(
              0,
              0,
              0,
              1,
              [
                {
                  offset: 0,
                  color: "rgba(0,244,255,1)", // 0% 处的颜色
                },
                {
                  offset: 1,
                  color: "rgba(0,77,167,1)", // 100% 处的颜色
                },
              ],
              false
            ),
            barBorderRadius: [30, 30, 30, 30],
            shadowColor: "rgba(0,160,221,1)",
            shadowBlur: 4,
          },
        },
      },
    ],
  };
  option && myChart.setOption(option);
};

//获取列表数据
const getList = async () => {
  const res: any = await getStatistics(datas.form);
  if (res.code == 200) {
    datas.total = res.data.total;
    datas.datasList = res.data.data;
    // 图表1数据
    if (res.data.data[0]) {
      datas.echarts1Tit = res.data.data[0]?.title.replace(/<[^>]+>/g, "");
      res.data.data[0].options.forEach((item: any, index: number) => {
        datas.echarts1X.push(item.description);
        datas.echarts1Data.push({
          value: item.count,
          name: item.description,
        });
      });
      initEcharts();
    }
    // 图表2数据
    if (res.data.data[1]) {
      datas.echarts2Tit = res.data.data[1]?.title.replace(/<[^>]+>/g, "");
      res.data.data[1].options.forEach((item: any, index: number) => {
        datas.echarts2Data.push({
          value: item.count,
          name: item.description,
        });
      });
      initEcharts2();
    }
    // 图表3数据
    if (res.data.data[2]) {
      datas.echarts3Tit = res.data.data[2]?.title.replace(/<[^>]+>/g, "");
      res.data.data[2].options.forEach((item: any, index: number) => {
        datas.echarts3Data.push({
          value: item.count,
          name: item.description,
        });
      });
      initEcharts3();
    }
    // 图表4数据
    if (res.data.data[3]) {
      datas.echarts4Tit = res.data.data[3]?.title.replace(/<[^>]+>/g, "");
      res.data.data[3].options.forEach((item: any, index: number) => {
        datas.echarts4DataX.push(item.description);
        datas.echarts4DataY.push(item.count);
      });
      initEcharts4();
    }
    // 图表5数据
    if (res.data.data[4]) {
      datas.echarts5Tit = res.data.data[4]?.title.replace(/<[^>]+>/g, "");
      res.data.data[4].options.forEach((item: any, index: number) => {
        datas.echarts5DataX.push(item.description);
        datas.echarts5DataY.push(item.count);
      });
      initEcharts5();
    }
    // 图表6数据
    if (res.data.data[5]) {
      datas.echarts6Tit = res.data.data[5]?.title.replace(/<[^>]+>/g, "");
      res.data.data[5].options.forEach((item: any, index: number) => {
        datas.echarts6DataX.push(item.description);
        datas.echarts6DataY.push(item.count);
      });
      initEcharts6();
    }
  }
};

onMounted(() => {
  getList();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[0] || (_cache[0] = _createElementVNode("span", { class: "main-top-title" }, "问卷提交量：", -1)),
        _createElementVNode("span", _hoisted_4, _toDisplayString(datas.total), 1)
      ]),
      _createElementVNode("div", { class: "main-top" }, [
        _createElementVNode("span", {
          class: "main-top-title",
          onClick: downLoad
        }, "导出")
      ])
    ]),
    _cache[1] || (_cache[1] = _createStaticVNode("<div class=\"main-center-box\" data-v-3331bef2><div id=\"mainCenterleft\" data-v-3331bef2></div><div id=\"mainCenterCenter\" data-v-3331bef2></div><div id=\"mainCenterRight\" data-v-3331bef2></div></div><div class=\"main-bottom-box\" data-v-3331bef2><div id=\"mainBottomLeft\" data-v-3331bef2></div><div id=\"mainBottomCenter\" data-v-3331bef2></div><div id=\"mainBottomRight\" data-v-3331bef2></div></div>", 2))
  ]))
}
}

})